import React, { useEffect, useState } from "react";

const DemoTerminal = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const [activeCA, setActiveCA] = useState(urlParams.get('ca')?.toLowerCase() || "bonk");
    const [marketData, setMarketData] = useState({ prices: {}, trades: [] });
    const [lastUpdated, setLastUpdated] = useState(new Date());

    const tokens = [
        { value: "bonk", label: "BONK" },
        { value: "wif", label: "WIF" },
        { value: "peace", label: "PEACE" },
        { value: "unc", label: "UNC" },
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch(`https://lead-demo-api.lakesidehotelhyd.workers.dev/?ca=${activeCA}`);
                const data = await res.json();
                if (data.status === "ok") {
                    setMarketData(data);
                    setLastUpdated(new Date());
                }
            } catch (err) {
                console.error(err);
            }
        };

        // Initial fetch
        fetchData();

        // Poll every 20 seconds (matches Worker cache perfectly)
        const interval = setInterval(fetchData, 20000);

        return () => clearInterval(interval);
    }, [activeCA]);

    const formatTime = (ts) => {
        return new Intl.DateTimeFormat('en-IN', {
            hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Kolkata'
        }).format(new Date(ts));
    };

    return (
        <div style={{
            background: "#020617",
            color: "#e2e8f0",
            minHeight: "100vh",
            fontFamily: "system-ui",
            margin: 0,
            padding: 0
        }}>
            <div style={{ maxWidth: "100%", margin: "0 auto", padding: "15px 10px" }}>
               
                {/* Top Bar */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "12px" }}>
                    <h1 style={{ fontSize: "26px", margin: 0 }}>
                        Asset: <span style={{ color: "#f3ba2f" }}>{marketData.prices.CUSTOM_NAME || activeCA.toUpperCase()}</span>
                    </h1>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span style={{ background: "#eab308", color: "#000", padding: "6px 14px", borderRadius: "9999px", fontSize: "13px", fontWeight: "bold" }}>DEMO MODE</span>
                        <select
                            value={activeCA}
                            onChange={e => setActiveCA(e.target.value)}
                            style={{ padding: "10px 14px", background: "#1e2937", border: "1px solid #334155", borderRadius: "8px", color: "#e2e8f0" }}
                        >
                            {tokens.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                        </select>
                    </div>
                </div>

                {/* Terminal */}
                <div style={{
                    background: "#0f172a",
                    borderRadius: "16px",
                    padding: "18px 12px",
                    border: "1px solid #1e2937",
                    overflowX: "auto",
                    width: "100%"
                }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "18px", flexWrap: "wrap" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                            <span style={{ fontSize: "22px", fontWeight: "bold" }}>🐳 WHALE FLOW — LIVE TAPE</span>
                            <span style={{ background: "#eab308", color: "#000", padding: "5px 14px", borderRadius: "9999px", fontSize: "13px", fontWeight: "bold" }}>$5,000+ WHALE TRADES</span>
                        </div>
                        <p style={{ color: "#64748b", margin: "5px 0 0", fontSize: "14px" }}>
                            Last Updated: {lastUpdated.toLocaleTimeString('en-IN')} IST
                        </p>
                    </div>

                    <table style={{ width: "100%", minWidth: "860px", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ borderBottom: "2px solid #334155" }}>
                                <th style={{ textAlign: "left", padding: "12px 8px", color: "#94a3b8" }}>TIME</th>
                                <th style={{ textAlign: "left", padding: "12px 8px", color: "#94a3b8" }}>SIDE</th>
                                <th style={{ textAlign: "right", padding: "12px 8px", color: "#94a3b8" }}>VALUE (USD)</th>
                                <th style={{ textAlign: "right", padding: "12px 8px", color: "#94a3b8" }}>AMOUNT</th>
                                <th style={{ textAlign: "left", padding: "12px 8px", color: "#94a3b8" }}>WALLET</th>
                                <th style={{ textAlign: "right", padding: "12px 8px", color: "#94a3b8" }}>NET WORTH</th>
                                <th style={{ textAlign: "center", padding: "12px 8px", color: "#94a3b8" }}>VERIFY</th>
                            </tr>
                        </thead>
                        <tbody>
                            {marketData.trades?.map((t, i) => (
                                <tr key={i} style={{ borderBottom: "1px solid #1e2937" }}>
                                    <td style={{ padding: "14px 8px", color: "#94a3b8" }}>{formatTime(t.time)}</td>
                                    <td style={{ padding: "14px 8px" }}>
                                        <span style={{ color: t.side === "BUY" ? "#22c55e" : "#ef4444", fontWeight: "bold" }}>{t.side}</span>
                                    </td>
                                    <td style={{ padding: "14px 8px", textAlign: "right", fontWeight: "bold", color: "#f3ba2f" }}>{t.valueDisplay}</td>
                                    <td style={{ padding: "14px 8px", textAlign: "right" }}>{t.amount}</td>
                                    <td style={{ padding: "14px 8px" }}>
                                        <a href={`https://solscan.io/account/${t.walletFull}`} target="_blank" rel="noreferrer" style={{ color: "#60a5fa" }}>
                                            {t.wallet}
                                        </a>
                                        {t.knownLabel && <span style={{ marginLeft: "8px", background: "#eab308", color: "#000", padding: "2px 8px", borderRadius: "4px", fontSize: "11px" }}>{t.knownLabel}</span>}
                                    </td>
                                    <td style={{ padding: "14px 8px", textAlign: "right", color: "#94a3b8" }}>{t.walletNetWorth}</td>
                                    <td style={{ padding: "14px 8px", textAlign: "center" }}>
                                        <a href={`https://solscan.io/tx/${t.signature}`} target="_blank" rel="noreferrer" style={{ color: "#f3ba2f", fontWeight: "bold" }}>VERIFY ↗</a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default DemoTerminal;
